export const SAVE_ALL_VEHICLE_COLORS = 'SAVE_ALL_VEHICLE_COLORS'